export default function setInsuredValue(
  insuredValue: number,
  coverageCode: string,
): number {
  return ['0049', '0040'].includes(coverageCode) ? 0 : insuredValue;
}
